export default {
  "content": "<rect width=\"18\" height=\"18\" fill=\"#8A8F9E\" rx=\"3\"/><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M8.064 14.362a1 1 0 01-1.306-.219l-2.754-3.4a1 1 0 01.148-1.406l.194-.158a1 1 0 011.407.148l1.73 2.136 4.826-6.894a1 1 0 011.393-.245l.205.143a1 1 0 01.245 1.393l-5.478 7.823a.995.995 0 01-.316.45l-.02.018a.992.992 0 01-.274.211z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "18",
    "height": "18",
    "fill": "none"
  }
};